import { useParams } from "react-router-dom";
import EventHeader from "../common/EventHeader";
import EventEditForm from "../event/EventEditForm";

const EventEditPage = () => {
  const { clientName } = useParams();
  return (
    <div>
      <EventHeader to={`/${clientName}`} />
      <main>
        <h1 className="mb-2 text-[36px] font-light  max-lg:text-[28px] max-sm:text-[22px]">
          Neue Veranstaltung
        </h1>
        <EventEditForm />
      </main>
    </div>
  );
};

export default EventEditPage;
